import { RequestOptions } from '@/types/Request'
import { request, ORIGIN } from '@/request/RequestWrapper'
import { queryStringBuilder } from '@/utils/util'

/**
 * 创建任务
 * @param loadingTarget 要显示 loading 的元素
 * @param job_id 任务ID
 * @param choose_data 选择的数据
 * @param method 选择的方法
 * @param requestOptions { RequestOptions } 请求选项
 */
// eslint-disable-next-line camelcase
function createTask (loadingTarget: HTMLElement | null, { job_id, choose_data, diffmap_n_com, embeding_rep, nearest_neighbors }: any, requestOptions: RequestOptions = {}) {
  const url = `${ORIGIN}/TrajectoryAnalysis/createTask`
  const options = {
    body: queryStringBuilder(arguments[1])
  }
  const messages = {
    error: 'fail to create task'
  }
  const params = { url, loadingTarget, messages, options, ...requestOptions }
  return request(params)
}

/**
 * 根据job id获取结果数据
 * @param loadingTarget 要显示 loading 的元素
 * @param jobId 任务ID
 * @param requestOptions 请求选项
 */
function getResultList (loadingTarget: HTMLElement | null, jobId: string, requestOptions: RequestOptions = {}) {
  const url = `${ORIGIN}/TrajectoryAnalysis/getResultByJobid?job_id=${jobId}`
  const options = {
    method: 'get'
  }
  const messages = {
    error: 'get result error'
  }
  const params = { url, loadingTarget, messages, options, ...requestOptions }
  return request(params)
}

export { createTask, getResultList }
